import React from 'react';
import { SiJavascript, SiPython, SiPhp, SiApple, SiAndroid } from 'react-icons/si';
import {Code} from '@mui/icons-material';

const SdkShowcase = () => {
    const sdks = [
        {
            icon: SiJavascript,
            name: 'Node.js SDK',
            version: 'v2.1.0',
            description: 'SDK officiel pour JavaScript/Node.js avec support TypeScript',
            features: ['Typage TypeScript', 'Support async/await', 'Tests unitaires'],
            color: 'yellow'
        },
        {
            icon: SiPython,
            name: 'Python SDK',
            version: 'v1.8.0',
            description: 'SDK Python avec support complet des APIs Netikash',
            features: ['Python 3.7+', 'Requests intégré', 'Documentation Sphinx'],
            color: 'blue'
        },
        {
            icon: SiPhp,
            name: 'PHP SDK',
            version: 'v2.3.0',
            description: 'SDK PHP moderne avec support Composer',
            features: ['PHP 7.4+', 'PSR standards', 'Guzzle HTTP'],
            color: 'purple'
        },
        {
            icon: Code,
            name: 'REST API',
            version: 'v1.0',
            description: 'API REST directement utilisable',
            features: ['JSON native', 'Tous langages', 'Documentation OpenAPI'],
            color: 'green'
        },
        {
            icon: SiApple,
            name: 'iOS SDK',
            version: 'v1.5.0',
            description: 'SDK natif pour iOS avec SwiftUI',
            features: ['Swift 5.0+', 'UIKit/SwiftUI', 'CocoaPods'],
            color: 'gray'
        },
        {
            icon: SiAndroid,
            name: 'Android SDK',
            version: 'v1.4.0',
            description: 'SDK Android avec Kotlin Coroutines',
            features: ['Kotlin first', 'Coroutines', 'Jetpack Compose'],
            color: 'green'
        }
    ];

    const getColorClasses = (color) => {
        const colors = {
            yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            blue: 'bg-blue-100 text-blue-800 border-blue-200',
            purple: 'bg-purple-100 text-purple-800 border-purple-200',
            green: 'bg-green-100 text-green-800 border-green-200',
            gray: 'bg-gray-100 text-gray-800 border-gray-200'
        };
        return colors[color] || 'bg-gray-100 text-gray-800 border-gray-200';
    };

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        SDKs Disponibles
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Choisissez le SDK qui correspond à votre stack technique.
                        Tous offrent les mêmes fonctionnalités avec une expérience développeur optimisée.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {sdks.map((sdk, index) => (
                        <div key={index} className="bg-white rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                            <div className="p-6">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="p-3 bg-gray-100 rounded-lg">
                                        <sdk.icon className="text-2xl text-gray-600" />
                                    </div>
                                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getColorClasses(sdk.color)}`}>
                    {sdk.version}
                  </span>
                                </div>

                                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                    {sdk.name}
                                </h3>

                                <p className="text-gray-600 text-sm mb-4">
                                    {sdk.description}
                                </p>

                                <ul className="space-y-2 mb-6">
                                    {sdk.features.map((feature, idx) => (
                                        <li key={idx} className="flex items-center text-sm text-gray-700">
                                            <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-3"></div>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                <div className="flex space-x-3">
                                    <button className="flex-1 bg-amber-500 text-white py-2 px-4 rounded text-sm font-medium hover:bg-amber-600 transition-colors">
                                        Installer
                                    </button>
                                    <button className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded text-sm font-medium hover:bg-gray-50 transition-colors">
                                        Docs
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SdkShowcase;